import { useQuery } from "@tanstack/react-query";
import { getWeightLogs } from "../services/firebase-weight-service";
import { getGuestWeights } from "../services/guestStorage";

export const useWeights = (uid) => {
  const isGuest = !uid || uid === "guest";

  return useQuery({
    queryKey: ["weights", uid],
    queryFn: () => (isGuest ? getGuestWeights() : getWeightLogs(uid)),
    enabled: true,
  });
};
